import React from 'react'
import "../Style/TreatmentCard.css"
const TreatmentCard = ({skin}) => {
  return (
    <div className='treatment-card-container'>
        <div>
        <h1 className="skin-head-1">{skin.heading.heading}</h1>
        <p className="skin-head-para">{skin.heading.para}</p>
      </div>
      <div className="treat-card">
        {skin.content.map((content) => (
          <div className="content-card-11">
            <div>
              <img src={content.imageUrl} />
            </div>
            <div>
            <p className="content-name-p"> {content.name}</p>
            <p className="content-desc-p">{content.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TreatmentCard;